<template>
  <button v-bind:class="[this.color, 'pseudo-button', 'sharing-button']">
    <span v-bind:class="[ 'shine', this.type === 'download' ? 'shine-1' : 'shine-2']"></span>
    <!--<img v-bind:src="getImgSrc()">-->
    <div>{{this.text}}</div>
  </button>
</template>

<script>
export default {
  data() {
    return {
      animate: false
    };
  },
  props: {
    text: String,
    imgPath: String,
    color: String,
    type: String
  },
  methods: {
    getImgSrc() {
      return require("@/assets/img/" + this.imgPath);
    }
  }
};
</script>


<style scoped>
button {
  position: fixed;
  border-width: 2px;
  overflow: hidden; /* for animation */
  border-color: var(--light-text-color);
  display: flex;
  padding-left: 15px;
  align-items: center;
  z-index: 5;
}

@media (max-width: 575.98px) {
  button {
    width: 50%;
    height: 40px;
    text-align: center;
    display: inline-block;
    padding: 0;
  }
  .pink {
    right: 0;
    border-style: none;
    border-radius: none;
    bottom: 0;
  }
  .blue {
    left: 0;
    border-style: none;
    border-radius: none;
    bottom: 0;
  }
}

@media (min-width: 576px) {
  button {
    right: 0px;
    min-width: 150px;
    height: 40px;
    border-radius: 25px 0px 0px 25px;
    border-style: solid none solid solid;
  }
  .pink {
    top: calc(var(--header-height));
  }
  .blue {
    top: calc(var(--header-height) + 45px);
  }
}

.pink {
  background-color: var(--tinder-pink-5);
}

.blue {
  background-color: var(--tinder-blue-1);
}

img {
  height: 20px;
  width: auto;
  margin: auto 10px auto 20px;
}

div {
  color: var(--light-text-color);
  font-weight: bold;
}

/** animation **/
button span.shine {
  content: "";
  position: absolute;
  height: 300px;
  width: 25px;
  background: white;
  display: block;
  opacity: 0.6;

  -webkit-box-shadow: 0px 0px 10px 5px white;
  -moz-box-shadow: 0px 0px 10px 5px white;
  box-shadow: 0px 0px 10px 5px white;

  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);

  animation-duration: 8s;
  animation-name: shine;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  -webkit-animation-duration: 8s;
  -webkit-animation-name: shine;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
}

.shine-1 {
  animation-delay: 0.07s;
  -webkit-animation-delay: 0.07s;
}

.shine-2 {
  animation-delay: 0s;
  -webkit-animation-delay: 0s;
}

@keyframes shine {
  0% {
    top: -80px;
    left: -20px;
  }
  5%,
  10% {
    left: 170px;
    top: -300px;
  }
  10%,
  88% {
    left: 170px;
    top: -300px;
  }
  93% {
    top: -80px;
    left: -20px;
  }
}

@-webkit-keyframes shine {
  0% {
    top: -80px;
    left: -20px;
  }
  5%,
  10% {
    left: 170px;
    top: -300px;
  }
  10%,
  88% {
    left: 170px;
    top: -300px;
  }
  93% {
    top: -80px;
    left: -20px;
  }
}


button .shine {
  left: 170px;
  top: -300px;
}
/*button:hover .shine {
  left: 170px;
  top: -300px;
}*/
</style>
